import { Component } from '@angular/core';
import { AlertMessageService } from '../../services/alert-message.service';
import { AlertMessageModel } from '../../models/common.model';

@Component({
  selector: 'app-error-alert-popup',
  templateUrl: './error-alert-popup.component.html',
  styleUrls: ['./error-alert-popup.component.css']
})
export class ErrorAlertPopupComponent {
  headerTitle:string="Error";
  messageText:string="";
  buttonText:string="Close";
  showError:boolean=false;
  displayValue:string = "";
  heightValue:string = "";
  // new: alert type for styling
  alertType: 'error' | 'success' | 'info' = 'error';
  confirmText:string = 'Yes';
  cancelText:string = 'No';
  isConfirmMode:boolean = false;
  private confirmCallback?: () => void;
  private cancelCallback?: () => void;

  constructor(private _alertService:AlertMessageService){}

  ngOnInit() {
    this._alertService.isAlert$.subscribe((alert:AlertMessageModel) => {
      const incomingType = (alert as any).type as ('success'|'error'|'info'|undefined);
      this.alertType = incomingType || (alert.header === 'Success' ? 'success' : alert.header === 'Info' ? 'info' : 'error');
      this.showError = alert.show;
      this.headerTitle = alert.header || (this.alertType === 'success' ? 'Success' : this.alertType === 'info' ? 'Info' : 'Error');
      this.messageText = alert.message || '';
      this.buttonText = this.alertType === 'success' ? 'Ok' : 'Close';
      // confirm mode
      this.isConfirmMode = !!(alert as any).confirm;
      if (this.isConfirmMode) {
        this.confirmText = (alert as any).confirmText || 'Confirm';
        this.cancelText = (alert as any).cancelText || 'Cancel';
        this.confirmCallback = (alert as any).onConfirm;
        this.cancelCallback = (alert as any).onCancel;
      } else {
        this.confirmCallback = undefined;
        this.cancelCallback = undefined;
      }
    });
  }
  close(){
    this.showError=false;
  }
  onOkBtnClick(){
    this.showError=false;
  }
  handleConfirm(){
    if (this.confirmCallback) {
      try { this.confirmCallback(); } catch(e){ console.error(e); }
    }
    this.showError=false;
  }
  handleCancel(){
    if (this.cancelCallback) {
      try { this.cancelCallback(); } catch(e){ console.error(e); }
    }
    this.showError=false;
  }
  customcss(messageText:any){
    if(messageText.length != 0){
      if(messageText.length > 300){
        this.heightValue = '100%';
        return '';
      }
      else{
        this.heightValue = '';
        return '';
      }
    }
    return '';
  }
  // helper class
  getPopupClass(){
    return {
      'alert-error': this.alertType === 'error',
      'alert-success': this.alertType === 'success',
      'alert-info': this.alertType === 'info'
    };
  }
}
